var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showBadge)?_c('PremiumFeatureBadge',{class:_vm.$style.icon,attrs:{"customText":"PREMIUM","showLearnMoreLink":false}}):_vm._t("else")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }